"use client";
import { NewsletterSubscription } from '@/app/components/newsletter/NewsletterSubscription';

export default function NewsletterPage() {
    return (
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-8">
                    <div className="text-center mb-5">
                        <h1 className="display-5 fw-bold mb-3">
                            <i className="bi bi-envelope-heart me-2" style={{ color: '#FFCC00' }}></i>
                            اشترك في النشرة الإخبارية
                        </h1>
                        <p className="lead text-muted">
                            انضم إلى مجتمع فيجماوية واحصل على آخر الأخبار والمحتوى الحصري مباشرة في بريدك الإلكتروني
                        </p>
                    </div>
                    <NewsletterSubscription />
                </div>
            </div>
        </div>
    );
}
